import styled from 'styled-components';

const FrameMobileStyled = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'fixed',
  width: '100%',
  height: 40,
  padding: `0 ${theme.space[3]}`,
  background: theme.color.wfBlack,
  // TODO use it from theme
  zIndex: 999999,
}));

export { FrameMobileStyled };
